module.exports = __webpack_public_path__ + "media/slot-game/arrow-back-795ab1db.svg";